module.exports = __webpack_public_path__ + "static/assets/6c229df5b2b7e3b1b036e89ed85d41db.svg";